import React from 'react';
import { TextLink, Typography, makeStyles } from '@ellucian/react-design-system/core';
import { spacing40 } from '@ellucian/react-design-system/core/styles/tokens';
import { useIntl } from 'react-intl';
import HtmlFormattedMessage from '../HtmlFormattedMessage/HtmlFormattedMessage';
import { useApi } from '../ApiContext';
import { useSnackbar } from '../SnackbarContext/SnackbarContext';

const useStyles = makeStyles(() => ({
    root: {
        padding: spacing40,
        width: '100%',
    },
    container: { 
        maxWidth: 800,
        margin: '4rem auto',
        display: 'flex',
        justifyContent: 'center'
    },
    content: {
        width: '100%'
    },
    message: {
        marginTop: spacing40,
        marginBottom: spacing40,
    },
}));

const MFAResetConfirm = () => {
    const intl = useIntl();
    const classes = useStyles();
    const api = useApi();
    const snackbar = useSnackbar();
    const confirmationMessage = decodeURI(intl.formatMessage({ id: 'applicationRetrievalAccountResetConfirmation' }));
    const userEmail = window.PRELOADED_STATE?.user?.email || '';
    const model = {
        email: userEmail,
    };
    const handleButtonClick = async () => {
        try {
            await api.inquiries.retrieve(model);
            snackbar.success(intl.formatMessage({ id: 'applicantResentCommunication' }, {
                who: userEmail,
            }));
        } catch (err) {
            snackbar.error(intl.formatMessage({ id: 'applicantResentCommunicationError' }));
        }
    };
    return (
        <div className={classes.root}>
            <div className={classes.container}>
                <div className={classes.content}>
                    <div className={classes.message}>
                        <Typography>
                            <HtmlFormattedMessage htmlString={confirmationMessage} />
                        </Typography>
                    </div>
                    <div>
                        <Typography variant='body2'>
                            <TextLink onClick={handleButtonClick}>
                                {intl.formatMessage({ id: 'resendEmailLinkTextId' })}
                            </TextLink>
                        </Typography>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MFAResetConfirm;
